import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BsArrowLeft } from 'react-icons/bs';
import { FaHome } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from 'src/app/store';

interface IHeaderProps {
  title: string;
  isShowBack: boolean;
  isShowMenu?: boolean;
  onPressBack?: () => void;
  isHideScroll?: boolean;
  setVisibleField?: (status: boolean) => void;
  isHideHomeIcon?: boolean;
  hideOnScrollOffset?: number;
}

const Header = ({
  title,
  isShowBack,
  onPressBack,
  isShowMenu,
  isHideScroll,
  setVisibleField,
  isHideHomeIcon,
  hideOnScrollOffset = 0,
}: IHeaderProps) => {
  const { t } = useTranslation(['main']);
  const pName = useLocation().pathname.split('/').reverse()[0];
  const navigate = useNavigate();
  const { shopId } = useAppSelector(state => state.order);

  //header scrolling mechanism
  const [scrollDirection, setScrollDirection] = useState<'down' | 'up' | null>(
    null,
  );

  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const updateScrollDirection = () => {
      const scrollY = window.scrollY;
      const direction = scrollY > lastScrollY ? 'down' : 'up';
      if (
        direction !== scrollDirection &&
        (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)
      ) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener('scroll', updateScrollDirection); // add event listener
    return () => {
      window.removeEventListener('scroll', updateScrollDirection); // clean up
    };
  }, [scrollDirection]);

  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY;
    setVisible(currentScrollY <= hideOnScrollOffset || !isHideScroll);
  }, [hideOnScrollOffset, isHideScroll]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    if (setVisibleField) setVisibleField(visible);
  }, [setVisibleField, visible]);

  const backHomeScreen = () => {
    navigate({
      pathname: `/home/${shopId}`,
    });
  };

  const cls = visible ? 'visible' : 'hidden';

  return (
    <div
      className={`${
        isHideScroll ? cls : ''
      } pb-[5px] flex items-center justify-between h-[40px]`}>
      {isShowBack ? (
        <div
          className="font-medium flex justify-start items-center"
          onClick={onPressBack}>
          <div className="h-[30px] w-[30px] bg-white rounded-[50%] flex items-center justify-center mr-[12px]">
            <BsArrowLeft fontSize={18} className="text-primary stroke-1" />
          </div>
          {/*<BiArrowBack className="flex text-primary" />*/}
          {/*<div className=" pl-3 text-[16px]">Back</div>*/}
          <div>{title}</div>
        </div>
      ) : (
        <div className="font-bold text-[16px]">{title}</div>
      )}
      {/*{isShowMenu && (*/}
      {!isHideHomeIcon && (
        <div
          className="font-medium flex justify-start items-center"
          onClick={backHomeScreen}>
          <FaHome fontSize={18} />
        </div>
      )}
      {/*} )}*/}
    </div>
  );
};

export default Header;
